import { createReducer } from "reduxsauce";

import ReducerRegister from "../../ReducerRegister";
import SettingService from "../../../services/screens/admin/SettingService";
import { ActionTypes } from "../../actionTypes/screens/admin/SettingActionTypes";
import AsyncActionReducers from "../../AsyncActionReducers";

import UIDs from "../../../UIDs";

const uid = UIDs.screens.admin.setting;

//
// Actions
//
const Actions = {
    loadScreenViewAsync: () => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.LOAD_SCREEN_VIEW_ASYNC });

            SettingService.loadScreenView(
                response => {
                    dispatch(Actions.loadScreenViewSuccess(response));
                },
                error => {
                    dispatch(Actions.loadScreenViewFailure(error));
                }
            );
        };
    },

    loadScreenViewSuccess: data => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_SUCCESS,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        postReducer: loadScreenViewSuccessPostReducer,
        data
    }),

    loadScreenViewFailure: error => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_FAILURE,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        error
    }),

    updateSettingAsync: (key, value) => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.UPDATE_SETTING_ASYNC, key, value });

            SettingService.updateSetting(
                key,
                value,
                response => {
                    dispatch(Actions.updateSettingSuccess(response, key, value));
                },
                error => {
                    dispatch(Actions.updateSettingFailure(error));
                }
            );
        };
    },

    updateSettingSuccess: (data, key, value) => ({
        type: ActionTypes.UPDATE_SETTING_SUCCESS,
        parentType: ActionTypes.UPDATE_SETTING_ASYNC,
        postReducer: updateSettingSuccessPostReducer,
        data,
        key,
        value
    }),

    updateSettingFailure: error => ({
        type: ActionTypes.UPDATE_SETTING_FAILURE,
        parentType: ActionTypes.UPDATE_SETTING_ASYNC,
        error
    }),

    resetDataAsync: () => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.RESET_DATA_ASYNC });

            SettingService.resetChineseParkData(
                response => {
                    dispatch(Actions.resetDataSuccess(response));
                },
                error => {
                    dispatch(Actions.resetDataFailure(error));
                }
            );
        };
    },

    resetDataSuccess: (data) => ({
        type: ActionTypes.RESET_DATA_SUCCESS,
        parentType: ActionTypes.RESET_DATA_ASYNC,
        data
    }),

    resetDataFailure: error => ({
        type: ActionTypes.RESET_DATA_FAILURE,
        parentType: ActionTypes.RESET_DATA_ASYNC,
        error
    })
};

//
// Initial State
//
const INITIAL_STATE = {
    settingKeys: null,
    settingValues: null,
    settingComments: null
};

//
// Reducers
//
const loadScreenViewSuccessPostReducer = (state, { data }) => {
    const { keys: settingKeys, values: settingValues, comments: settingComments } = data.applicationSetting;
    return { ...state, settingKeys, settingValues, settingComments };
};

const updateSettingSuccessPostReducer = (state, { key, value }) => {
    const { settingKeys, settingValues } = state;
    let values = Array.from(settingValues);
    const idx = settingKeys.indexOf(key);
    values[idx] = value;
    
    return { ...state, settingValues: values };
};

// Use reduxsauce's createReducer to make it clearer for
// each action handler
const mergedReducer = createReducer(INITIAL_STATE, {
    [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.UPDATE_SETTING_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.UPDATE_SETTING_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.UPDATE_SETTING_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.RESET_DATA_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.RESET_DATA_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.RESET_DATA_FAILURE]: AsyncActionReducers.failureReducer
});

// Enable dynamically register and unregister reducer
const reducer = new ReducerRegister(uid, mergedReducer);

export { ActionTypes, Actions, reducer, INITIAL_STATE };
